import { Grid } from "@mui/material";
import React from "react";
import { TestLLMClassifierAgreementResult } from "models/LLMs/Testing/TestLLMClassifierAgreementResult";
import { ErrorExplanation } from "../ErrorExplanation";
import { GoToConversation } from "../GoToConversation";
import { LLMExecutionResultInformation } from "../LLMExecutionResultInformation";
import { TestedConversationDetails } from "../TestedConversationDetails";
import { ViewLabeling } from "../ViewLabeling";
import { ViewTranscript } from "../ViewTranscript";

interface ErrorResultProps {
    result: TestLLMClassifierAgreementResult;
    number: number;
}

export function ErrorResult({ result, number }: ErrorResultProps) {
    return (
        <React.Fragment>
            <TestedConversationDetails
                conversation={result.conversation}
                number={number}
                wouldExecuteUnderConditions={result.wouldExecuteUnderConditions}
                labels={{
                    human: result.conversation.labeled,
                    model: result.decision,
                }}
            />
            {result.errors.map((error, i) => (
                <ErrorExplanation error={error} key={i} />
            ))}
            {result.executionResult && (
                <LLMExecutionResultInformation
                    executionResult={result.executionResult}
                >
                    <LLMExecutionResultInformation.StepRunInformation />
                    <LLMExecutionResultInformation.StepVariables />
                    <LLMExecutionResultInformation.ClassifierResultsToWrite />
                    <LLMExecutionResultInformation.ExtendedMetadataToWrite />
                </LLMExecutionResultInformation>
            )}
            <Grid
                container
                item
                columnGap={1}
                alignSelf="flex-end"
                width="fit-content"
            >
                <Grid item>
                    <GoToConversation conversationId={result.conversation.id} />
                </Grid>
                <Grid item>
                    <ViewLabeling conversation={result.conversation} />
                </Grid>
                {result.executionResult?.transcript && (
                    <Grid item>
                        <ViewTranscript
                            transcript={result.executionResult.transcript}
                        />
                    </Grid>
                )}
            </Grid>
        </React.Fragment>
    );
}
